'use client';
import styled from 'styled-components';
import { device, typography } from '@/styles/helpers';

export const ScProviderSection = styled.section`
  margin-top: 32px;
`;

export const ScProviderHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const ScProviderLogo = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  margin-left: 8px;
  & .img-provider {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ScProviderName = styled.span`
  ${typography.headline2};
  color: ${({ theme }) => theme.whiteColor};
  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;
  @media (${device.mobile}) {
    ${typography.headline2mobile};
  }
`;
